import { ActiveOptionsStatus } from "../../assets/components/SearchBar/SearchBarSelectStatus/helpers";
import { StatusMaskLicense, TypeMaskLicense } from "./helpers";

export interface FetchQuiresLicenseKeys {
    pageNumber?: number;
    pageSize?: number;
    licenseKey?: string;
    status?: ActiveOptionsStatus;
    userId?: number[];
    productId?: number[];
    startDate?: number;
    endDate?: number;
    orderId?: string;
    sortNextRebillDate?: boolean;
    nextRebillStartDate?: number;
    nextRebillEndDate?: number;
}

export type LicenseList = OneLicense[];
export type TotalLicenses = number;

export type LicenseData = {
    totalLicenses: TotalLicenses;
    detailedInfo: LicenseList;
    filteredLicensesCount: number | undefined;
};
export type LicenseKeys = string[];

export interface OneLicense {
    product: LicenseProduct;
    license: License;
    user: User;
}

export interface LicenseProduct {
    title: string;
    days: number;
}

export interface License {
    id: number;
    key: string;
    allowedMachineActivationCount: number;
    readyForActivation: boolean;
    creationDate: number;
    type: TypeMaskLicense;
    status: StatusMaskLicense;
    nextRebillDate: number;
    lastRebillDate: number;
    activations: Activation[];
    migrationKeyId: number | null;
    orderId?: number;
    reason?: string | null;
}

export type UpdateActivationLimitLicense = {
    licenseId: License["id"];
    // groupId: number; For future use
    allowedMachineActivationCount: License["allowedMachineActivationCount"];
};

export type RemoveActivationLicense = {
    licenseKey: License["key"];
    activationIds: Array<Activation["id"]>;
};
export interface Activation {
    id: number;
    expirationDate: number;
    activationDate: number;
    machineId: string;
}

export interface User {
    id: number;
    role: string;
    resellerName: string;
    userName: string;
}

export const LicenseKeysModel = {
    product: {
        Title: "title",
        Days: "days",
    },
    license: {
        Id: "id",
        Key: "key",
        LicenseServerActivationCount: "licenseServerActivationCount",
        LicenseAllowedMachineActivationCount:
            "licenseAllowedMachineActivationCount",
        ReadyForActivation: "readyForActivation",
        CreationDate: "creationDate",
        ExpirationDay: "expirationDay",
        ActivationDate: "activationDate",
        Status: "status",
        Type: "type",
    },
    user: {
        Id: "id",
        Role: "role",
        ResellerName: "resellerName",
        UserName: "userName",
    },
};
